module.exports = __webpack_public_path__ + "img/Mundial-webpost_310x588.9f042f02.jpg";